import { FC } from 'react';
import { Modal } from 'react-bootstrap';

interface UserTableModalProps {
    user: any;
    onClose: () => void;
    show: boolean;
}

const formatDateForInput = (timestamp: number) => {
    if (!timestamp || isNaN(timestamp)) return '';
    try {
        const date = new Date(timestamp);
        if (isNaN(date.getTime())) return '';

        const month = date.getMonth() + 1; // No padding with zeros
        const day = date.getDate(); // No padding with zeros
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    } catch {
        return '';
    }
};

export const UserTableModal: FC<UserTableModalProps> = ({ user, onClose, show }) => {
    // console.log("user in UserTableModal", user.packagingType)

    return (
        <Modal
            className='modal fade'
            id='kt_modal_view_user'
            data-backdrop='static'
            tabIndex={-1}
            role='dialog'
            show={show}
            centered
            size="lg"
        >
            <div className="modal-content">
                <div className="modal-header pb-0 border-0 justify-content-end">
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={onClose}>X
                    </div>
                </div>

                <div className="modal-body scroll-y mx-5 mx-xl-18 pt-0">
                    <div className="text-center mb-13">
                        <h1 className="mb-3">Item Details</h1>
                    </div>






                    <div className="table-responsive">
                        {/* <p style={{ fontWeight: "bold" }}>Purchase Request Info</p> */}
                        <table style={{
                            width: '100%',
                            borderCollapse: 'collapse',
                            marginBottom: '20px',
                            tableLayout: 'fixed' // This helps maintain consistent column widths
                        }}>



                            <thead >
                                <tr >
                                    <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}>Delivery Address</th>
                                </tr>
                            </thead>




                            <tbody>
                                <tr>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>
                                        <span>
                                            {user?.deliveryAddress || 'N/A'}
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>












                    <div className="table-responsive">
                        {/* <p style={{ fontWeight: "bold" }}>Purchase Request Info</p> */}
                        {/* <table className="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3">
                            <thead>
                                <tr className="fw-bold text-muted bg-light">
                                    <th className="min-w-100px ps-4"
                                        style={{
                                            backgroundColor: '#BFD7ED',
                                            color: 'black',
                                            fontWeight: 'bold'
                                        }}>Category</th>
                                    <th className="min-w-100px ps-4"
                                        style={{
                                            backgroundColor: '#BFD7ED',
                                            color: 'black',
                                            fontWeight: 'bold'
                                        }}>Item</th>
                                    <th className="min-w-100px ps-4"
                                        style={{
                                            backgroundColor: '#BFD7ED',
                                            color: 'black',
                                            fontWeight: 'bold'
                                        }}>Grade</th>
                                    <th className="min-w-100px ps-4"
                                        style={{
                                            backgroundColor: '#BFD7ED',
                                            color: 'black',
                                            fontWeight: 'bold'
                                        }}>Color</th>
                                    <th className="min-w-100px ps-4"
                                        style={{
                                            backgroundColor: '#BFD7ED',
                                            color: 'black',
                                            fontWeight: 'bold'
                                        }}>Packaging</th>

                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td className="ps-4">
                                        <span className="text-dark fw-semibold d-block fs-6">
                                            {user?.orderDetail?.[0]?.categoryName || 'N/A'}
                                        </span>
                                    </td>
                                    <td>
                                        <span className="text-dark fw-semibold d-block fs-6">
                                            {user?.orderDetail?.[0]?.items?.[0]?.itemName || 'N/A'}
                                        </span>
                                    </td>
                                    <td>
                                        <span className="text-dark fw-semibold d-block fs-6">
                                            {user?.orderDetail?.[0]?.items?.[0]?.grade || 'N/A'}
                                        </span>
                                    </td>
                                    <td>
                                        <span className="text-dark fw-semibold d-block fs-6">
                                            {user?.orderDetail?.[0]?.items?.[0]?.color || 'N/A'}
                                        </span>
                                    </td>
                                    <td>
                                        <span className="text-dark fw-semibold d-block fs-6">
                                            {user?.packagingType || 'N/A'}
                                        </span>
                                    </td>
                                  

                                </tr>
                            </tbody>
                        </table> */}



                        {/* <table className="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3">
                            <thead>
                                <th className="min-w-100px ps-4"
                                    style={{
                                        backgroundColor: '#BFD7ED',
                                        color: 'black',
                                        fontWeight: 'bold'
                                    }}>Quantity (Kg)</th>
                                <th className="min-w-100px ps-4"
                                    style={{
                                        backgroundColor: '#BFD7ED',
                                        color: 'black',
                                        fontWeight: 'bold'
                                    }}>Price (INR/Kg)</th>
                                <th className="min-w-100px ps-4"
                                    style={{
                                        backgroundColor: '#BFD7ED',
                                        color: 'black',
                                        fontWeight: 'bold'
                                    }}>Delivery Date</th>
                            </thead>
                            <tbody>
                                <tr>
                                    <td className="ps-4">
                                        <span className="text-dark fw-semibold d-block fs-6">
                                            {user?.orderDetail[0]?.items[0]?.quantity || 'N/A'}
                                        </span>
                                    </td>
                                    <td>
                                        <span className="text-dark fw-semibold d-block fs-6">
                                            {user?.orderDetail[0]?.items[0]?.price || 'N/A'}
                                        </span>
                                    </td>
                                    <td>
                                        <span className="text-dark fw-semibold d-block fs-6">
                    
                                            {formatDateForInput(user?.deliveryDate)}
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table> */}



                    </div>












                    {/* <div className="table-responsive">
                        <p style={{ fontWeight: "bold" }}>Purchase Order Info</p>
                        <table className="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3">
                            <thead>
                                <tr className="fw-bold text-muted bg-light">
                                    <th className="min-w-100px ps-4"
                                        style={{
                                            backgroundColor: '#BFD7ED',
                                            color: 'black',
                                            fontWeight: 'bold'
                                        }}>Quantity (Kg)</th>
                                    <th className="min-w-100px ps-4"
                                        style={{
                                            backgroundColor: '#BFD7ED',
                                            color: 'black',
                                            fontWeight: 'bold'
                                        }}>Price (INR/Kg)</th>
                                    <th className="min-w-100px ps-4"
                                        style={{
                                            backgroundColor: '#BFD7ED',
                                            color: 'black',
                                            fontWeight: 'bold'
                                        }}>Delivery Date</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td className="ps-4">
                                        <span className="text-dark fw-semibold d-block fs-6">
                                            {user.confirmedOrderDetails?.[0]?.items?.[0].quantity}
                                        </span>
                                    </td>
                                    <td>
                                        <span className="text-dark fw-semibold d-block fs-6">
                                            {user.confirmedOrderDetails?.[0]?.items?.[0].price}
                                        </span>
                                    </td>
                                    <td>
                                        <span className="text-dark fw-semibold d-block fs-6">
                                            {formatDateForInput(user.confirmedDeliveryDate)}
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div> */}






                    {/* <div className="modal-content"> */}
                    {/* <div className="modal-header pb-0 border-0 justify-content-end">
                            <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={onClose}>
                            </div>
                        </div> */}




                    {/* </div> */}






                    <div className="table-responsive">
                        <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: "20px" }}>
                            <thead>
                                <tr>
                                    <th style={{ width: "33%", backgroundColor: "#BFD7ED", padding: "10px", fontWeight: "bold", textAlign: "left", border: "1px solid #ddd" }}>Order Information</th>
                                    <th style={{ width: "33%", backgroundColor: "#BFD7ED", padding: "10px", fontWeight: "bold", textAlign: "left", border: "1px solid #ddd" }}>Purchase Request</th>
                                    <th style={{ width: "33%", backgroundColor: "#BFD7ED", padding: "10px", fontWeight: "bold", textAlign: "left", border: "1px solid #ddd" }}>Purchase Order</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', fontWeight: "bold" }}>Category</td>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>{user?.orderDetail?.[0]?.categoryName || 'N/A'}</td>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>{"-"}</td>
                                </tr>
                                <tr>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', fontWeight: "bold" }}>Item</td>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>{user?.orderDetail?.[0]?.items?.[0]?.itemName || 'N/A'}</td>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>{"-"}</td>
                                </tr>
                                <tr>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', fontWeight: "bold" }}>Grade</td>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>{user?.orderDetail?.[0]?.items?.[0]?.grade || 'N/A'}</td>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>{'-'}</td>
                                </tr>
                                <tr>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', fontWeight: "bold" }}>Color</td>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>{user?.orderDetail?.[0]?.items?.[0]?.color || 'N/A'}</td>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>{'-'}</td>
                                </tr>
                                <tr>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', fontWeight: "bold" }}>Packaging</td>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>{user?.packagingType || 'N/A'}</td>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>{'-'}</td>
                                </tr>
                                <tr>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', fontWeight: "bold" }}>Quantity (Kg)</td>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>{user?.orderDetail?.[0]?.items?.[0]?.quantity || 'N/A'}</td>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>{user.confirmedOrderDetails?.[0]?.items?.[0].quantity || 'N/A'}</td>
                                </tr>
                                <tr>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', fontWeight: "bold" }}>Price (INR/Kg)</td>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>{user?.orderDetail?.[0]?.items?.[0]?.price || 'N/A'}</td>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>{user.confirmedOrderDetails?.[0]?.items?.[0].price || 'N/A'}</td>
                                </tr>
                                <tr>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', fontWeight: "bold" }}>Delivery Date</td>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>{formatDateForInput(user?.deliveryDate) || 'N/A'}</td>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>{formatDateForInput(user.confirmedDeliveryDate) || 'N/A'}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>



                    <table style={{
                        width: '100%',
                        borderCollapse: 'collapse',
                        marginBottom: '20px',
                        tableLayout: 'fixed' // This helps maintain consistent column widths
                    }}>
                        <thead style={{ backgroundColor: '#BFD7ED' }}>
                            <tr>
                                <th className=" ps-4"
                                    style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}
                                >Advance (INR)</th>
                                <th
                                    style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}
                                >UTR Number</th>
                                <th
                                    style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}
                                >PO Copy</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>
                                    <span>
                                        {user?.paymentInfo?.amount || 'N/A'}
                                    </span>
                                </td>
                                <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>
                                    <span >
                                        {user?.paymentInfo?.paymentId || 'N/A'}
                                    </span>
                                </td>


                                <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>
                                    {user?.paymentInfo?.images?.[0]?.docUrl ? (
                                        <i
                                            className="bi bi-file-pdf text-danger cursor-pointer"
                                            style={{ fontSize: '3rem' }}
                                            onClick={() => window.open(user.paymentInfo.images[0].docUrl, '_blank')}
                                            title="View PDF"
                                        ></i>
                                    ) : (
                                        'N/A'
                                    )}
                                </td>


                            </tr>
                        </tbody>
                    </table>

                    {user?.remarks && <div className="table-responsive">
                        {/* <p style={{ fontWeight: "bold" }}>Purchase Request Info</p> */}
                        <table style={{
                            width: '100%',
                            borderCollapse: 'collapse',
                            marginBottom: '20px',
                            tableLayout: 'fixed' // This helps maintain consistent column widths
                        }}>



                            <thead >
                                <tr >
                                    <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#bfd7ed', fontWeight: 600 }}>Remarks</th>
                                </tr>
                            </thead>




                            <tbody>
                                <tr>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>
                                        <span>
                                            {user?.remarks || 'N/A'}
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>}








                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-light"
                            onClick={onClose}
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>



















        </Modal>
    );
};